<footer
  class="w-full flex items-center justify-between px-4 py-2 bg-gray-100 border-t border-gray-200 text-sm dark:bg-gray-900 dark:border-gray-800 dark:text-gray-300"
>
  <div class="flex-1"></div>
  <div class="flex flex-col items-center">
    <span>{{ companyName }}</span>
    <span class="footer-note text-gray-500 dark:text-gray-400">© {{ currentYear }} All rights reserved.</span>
  </div>
  <div class="flex-1 flex flex-col items-end space-y-1">
    <span class="footer-note text-gray-500 dark:text-gray-400 flex items-center gap-1">
      <i class="pi pi-clock mr-1"></i>
      Now {{ currentDate }}
    </span>
    <span class="footer-note text-gray-500 dark:text-gray-400 flex items-center gap-1">
      <i class="pi pi-globe mr-1"></i>
      {{ timeZone }}
    </span>
  </div>
</footer>
